import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ArchiveIcon from "@material-ui/icons/Archive";
import Build from "@material-ui/icons/Build";
import Business from "@material-ui/icons/Business";
import DevicesOther from "@material-ui/icons/DevicesOther";
import DonutSmallIcon from "@material-ui/icons/DonutSmall";
import Equalizer from "@material-ui/icons/Equalizer";
import Receipt from "@material-ui/icons/Receipt";
import Settings from "@material-ui/icons/Settings";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
// import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";

// const server = EnvSettings.server;

function BadgeLink({ href, title, icon: Icon, iconStyle, style }) {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, {
    height: 200,
    cursor: "pointer",
    minWidth: 300,
  });
  const history = useHistory();
  return (
    <Grid item style={{ cursor: "pointer" }}>
      <Paper
        onClick={() => {
          history.push(href);
        }}
        className={fixedHeightPaper}
      >
        <Grid container justify="center" direction="column" alignItems="center">
          {Icon ? (
            <Grid item>
              <Icon style={iconStyle} />
            </Grid>
          ) : null}
          <Grid item>
            <Typography style={{ textAlign: "center" }}>{title}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

/**
 *
 * Moduuli softalle --> julkaisut, asennuksien lukumäärät ja kaatumiset
 * Moduuli laitteille --> ajot ja niiden tilastot == Dashboard
 * Moduuli siirroille --> uusimmat siirrot
 * Moduuli huollolle --> uusimmat tiketit ja huomautukset
 * Moduuli asiakkaille
 *
 * @param {*} props
 * @returns
 */

export default function ControlPanel(props) {
  const { t } = useTranslation();
  const badgeLinks = [
    {
      href: "/cpanel/software",
      title: t("software.header"),
      icon: ArchiveIcon,
    },
    {
      href: "/cpanel/devices/dashboard",
      title: t("devices.header"),
      icon: DevicesOther,
    },
    {
      href: "/cpanel/production",
      title: t("lifeCycleManagement.header"),
      icon: DonutSmallIcon,
    },
    {
      href: "/cpanel/tickets",
      title: t("maintenance.header"),
      icon: Build,
    },
    {
      href: "/cpanel/contacts",
      title: t("contacts.header"),
      icon: Business,
    },
    {
      href: "/cpanel/system",
      title: t("system.header"),
      icon: Settings,
    },
    {
      href: "/cpanel/stock",
      title: t("stock.header"),
      icon: Equalizer,
    },
    {
      href: "/cpanel/orders",
      title: t("orders.header"),
      icon: Receipt,
    },
  ];

  return (
    <Grid container spacing={3} justify="center">
      {/* All the admin items as badges */}
      {badgeLinks
        .sort((a, b) => {
          return a.title > b.title ? 1 : -1;
        })
        .map((b, i) => (
          <BadgeLink key={i} href={b.href} title={b.title} icon={b.icon} />
        ))}
    </Grid>
  );
}
